<template>
    <div class="row">
        <TitleComponent class="col-12 col-md-8" title="1. Selecciona tu asiento" subtitle="Si lo deseas, también puedes escoger varios asientos a la vez" />
        <div class="col-12 col-md-4 mb-3 text-center">
            <template>
                <h3>ZONA SELECCIONADA:</h3>
                <h4 v-if="zona">{{ zona.name }}</h4>
            </template>
            <Button @click="cambiarPaso()">Cambiar zona</Button>
        </div>
        <ContentOrLoading class="col-12">
            <template v-if="!loading">
                <div class="row h-100">
                    <div class="p-0 col-12 col-md-8">
                        <RecintoAnexoComponent
                            v-if="plazas"
                            class="col-12"
                            :region_id="zona.id"
                            :plazas="plazas"
                            :plazasSeleccionadas="[]"
                            :plazaParaBorrar="plazaParaBorrar"
                            :continuarConCompra="continuarConCompra"
                            :tipo_svg="parseInt(zona.tipo_svg, 10)"
                            :precios="precios"
                            :asientos_maximos="asientos_maximos"
                            :disabled="datos_compradores.length == 0"
                            :bloquearPasoDos="bloquearPasoDos"
                            @clickZona="clickZona"
                            @clearButacas="datos_compradores.splice(0, datos_compradores.length);"
                            @setPlazaBorrar="setPlazaBorrar"
                        />
                    </div>
                    <div class="col-12 col-md-4 mt-3 mt-md-0">
                        <div class="d-block text-center d-md-flex justify-content-between align-items-center mb-3 pl-3 pr-3">
                            <h3 class="mt-2">TUS ASIENTOS</h3>
                            <Button @click="showModalBloquearAsientos()" :disabled="bloquearPasoDos || (datos_compradores && datos_compradores.length === 0)">BLOQUEAR / LIBERAR BUTACAS</Button>
                        </div>
                        <div class="col-12 text-center" v-if="datos_compradores && datos_compradores.length === 0">
                            <p>Seleccione los asientos para continuar</p>
                        </div>
                        <template v-else>
                            <div class="overflow-auto mb-2 p-2 p-md-0" style="max-height: 446px;">
                                <div v-for="(asiento, index) in datos_compradores" :key="index">
                                    <TusPlazasComponent :butaca="asiento" :index="index" :disabled="bloquearPasoDos" @borrar-plaza="setPlazaBorrar(asiento)" :key="index"/>
                                </div>
                            </div>
                            <div v-if="teatro.carrito_varios_eventos" class="d-flex flex-row justify-content-center mt-3">
                                <template v-if="(carrito && carrito.items_count == 0) || !carrito">
                                    <Button @click="bloquearButacas" class="btn btn-primary mb-2 mb-md-0 me-md-2 mr-1" :disabled="bloquearPasoDos" style="flex: 1;">Continuar</Button>
                                    <Button id="add-cart" @click="checkCarrito()" class="btn btn-secondary ml-0 ml-md-1 mr-1 mr-md-0 mb-2 mb-md-0" :disabled="bloquearPasoDos || disableButtonCart"><i class="fa fa-cart-plus" aria-hidden="true"></i></Button>
                                </template>
                                <Button id="add-cart" v-else @click="checkCarrito()" class="btn btn-secondary ml-0 ml-md-1 mr-1 mr-md-0" :disabled="bloquearPasoDos || disableButtonCart" style="flex: 1;">AÑADIR AL CARRITO</Button>
                            </div>
                            <Button v-else class="btn-block" @click="bloquearButacas" :disabled="bloquearPasoDos">Continuar</Button>
                        </template>
                    </div>
                    <BloquearButacas
                        v-if="datos_compradores.length > 0 && !bloquearPasoDos"
                        :butacas="datos_compradores"
                        @bloquearButacas="bloquearAsientosManual"
                        @close="closeModalBloquearAsientos"
                    />
                </div>
            </template>
        </ContentOrLoading>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import RecintoAnexoComponent from '@/components/svg/RecintoAnexoComponent';
    import TusPlazasComponent from '../components/TusPlazasComponent.vue';
    import BloquearButacas from '../components/BloquearButacas.vue';

    export default {
        props: ['zona', 'datos_compradores', 'precios', 'continuarConCompra', 'recinto', 'asientos_maximos', 'bloquearPasoDos'],
        created() {
            if (this.recinto) {
                this.getPlazas();
            }
        },
        data() {
            return {
                loading: false,
                plazas: null,
                plazaParaBorrar: null,
                disableButtonCart: false
            }
        },
        methods: {
            clickZona(plazaSeleccionada) {
                this.plazas.find(plaza => {
                    if (plaza.id == plazaSeleccionada.id) {
                        plaza.seleccionada = plaza?.seleccionada && plaza.seleccionada ? false : true;
                        if (plaza.seleccionada) {
                            this.datos_compradores.push(plaza)
                        } else {
                            const index = this.datos_compradores.findIndex(plaza => plaza.id == plazaSeleccionada.id);
                        
                            if (index !== -1) {
                                this.datos_compradores.splice(index, 1);
                            }
                        }                    
                    }
                })
            },
            setPlazaBorrar(plaza) {
                this.plazaParaBorrar = this.plazaParaBorrar?.id === plaza.id ? null : plaza;
            },
            bloquearButacas() {
                const data = this.datos_compradores.map(plaza => {
                    return { plazaId: plaza.id }
                });

                const params = {
                    filters: {},
                    event_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    zona_id: this.zona.id,
                    data: data
                }

                this.$store.dispatch(this.config.getVuexAlias('back.event.sesiones.zonas.taquilla.bloquear-plazas'), params)
                    .then(({ data }) => {
                        sessionStorage.setItem('session_id', data.session_id);
                        this.$emit('goTo', 3, this.datos_compradores, data.session_id);
                    })
                    .catch(() => {
                        this.$toast.error('Butaca/s ocupada/s');
                    });
            },
            getPlazas() {
                this.loading = true;
                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    recinto_id: this.recinto.id,
                    region_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.taquilla.recinto.zonas-anexas.butacas'), params).then(res => {
                    this.plazas = res.data.data;
                }).catch(() => {
                    console.warn('Ha ocurrido un error recuperando las plazas');
                }).finally(() => {
                    this.loading = false;
                });
            },
            cambiarPaso() {
                this.$emit('cambiarPaso', 1, true);
            },
            bloquearAsientosManual(concepto, etiqueta) {
                this.loading = true;

                const params = {
                    filters: {},
                    concepto: concepto,
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    zona_id: this.zona.id,
                    n_butacas: this.asientos_maximos,
                    plazasSeleccionadas: this.datos_compradores,
                    asientos: []
                };

                if(etiqueta){
                    params.etiqueta_bloqueo_id = etiqueta.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.bloquear.asientos'), params).then(res => {
                    if (this.recinto) {
                        this.getPlazas();
                    }
                    this.$emit('reset');
                    this.reload += 1
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            showModalBloquearAsientos() {
                this.$modal.show('bloquearButacas');
            },
            closeModalBloquearAsientos() {
                this.$modal.hide('bloquearButacas');
            },
            checkCarrito() {
                if (this.carrito) {
                    this.setItemsCarrito();
                } else {
                    this.crearCarrito();
                }
            },
            crearCarrito() {
                const params = {filters: {}};

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.crear'), params).then(res => {
                    this.setItemsCarrito();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                })
            },
            setItemsCarrito() {
                this.disableButtonCart = true;

                const params = {
                    filters: {},
                    cart_id: this.carrito?.id,
                    plazas: this.getPlazasFormatted(),
                    asientos: []
                };

                this.$store.dispatch(this.config.getVuexAlias('taquilla.carrito.add-items'), params).then(res => {
                    this.$toast.success('Entradas añadidas al carrito correctamente.');
                    this.$store.dispatch('TAQUILLA_CARRITO_ACTIVO');
                    this.$router.push({path: "/admin/eventos"});
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.disableButtonCart = false;
                });
            },
            getPlazasFormatted() {
                let plazas = [];

                this.datos_compradores.map(plaza => {
                    plazas.push({
                        precio: {
                            id: plaza.precios[0].id
                        },
                        id: plaza.id,
                        event_id: this.evento_id,
                        event_session_id: this.sesion_id,
                        region_id: plaza.region_id
                    })
                });

                return plazas;
            }
        },
        computed: {
            evento_id() {
                return this.$route.params.evento_id;
            },
            sesion_id() {
                return this.$route.params.sesion_id;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            carrito() {
                return this.$store.getters.getCarritoActivo;
            }
        },
        mounted() {
            window.addEventListener('update-plano', this.getCarritoActivo);
        },
        components: { TitleComponent, RecintoAnexoComponent, TusPlazasComponent, BloquearButacas }
    }
</script>
